import { render, staticRenderFns } from "./splitted-bag-add-production-location-dialog.vue?vue&type=template&id=09fd69ba&scoped=true&lang=pug&"
import script from "./splitted-bag-add-production-location-dialog.vue?vue&type=script&lang=ts&"
export * from "./splitted-bag-add-production-location-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./splitted-bag-add-production-location-dialog.vue?vue&type=style&index=0&id=09fd69ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fd69ba",
  null
  
)

export default component.exports